// superadmin/pages/LoginPage.jsx

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../../shared/components/Logo";

const LoginPage = ({ onLogin }) => {

  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async () => {

    setError("");

    if (!email || !password)
      return setError("Please enter both email and password.");

    if (!email.includes("@"))
      return setError("Please enter a valid email address.");

    if (password.length < 4)
      return setError("Password must be at least 4 characters.");

    setLoading(true);

    try {
      
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/superadmin/login`, {

        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: email,
          password: password
        })
      });

      const data = await response.json();

      setLoading(false);

      if (!response.ok || !data.success) {
        return setError(data.message || "Login failed");
      }

      // store token
      localStorage.setItem("admin_token", data.token);

      // store admin name
      localStorage.setItem("admin_name", data.admin.name);
      
      // update React auth state
      onLogin(data.admin.name);

      // redirect
      navigate("/superadmin/dashboard");

    } catch (err) {

      setLoading(false);
      setError("Unable to connect to server.");

    }

  };

  return (
    <div className="login-page">

      <div className="login-card">

        <div className="login-heading">
          Administrator Login
        </div>

        <div className="login-subtext">
          Sign in to your account to continue
        </div>

        {error && <div className="error-box">{error}</div>}

        <label className="form-label">Email</label>

        <input
          className="form-input"
          type="email"
          placeholder="admin@digioxide.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
        />

        <label className="form-label">Password</label>

        <input
          className="form-input"
          type="password"
          placeholder="••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
        />

        <button
          className="btn-primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Signing in..." : "Sign In →"}
        </button>

      </div>

    </div>
  );
};

export default LoginPage;